import { useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'

import { userAtom } from '@/atoms/_globalAtoms'
import { roleAtom } from '@/atoms/globalAtoms'
import {
  EDIT_TOKEN_ROLE,
  EDIT_TOKEN_STORAGE_KEYS,
  EDITOR_USER_ROLE,
  userTypes,
} from '@messenger/consts'

export const useAdminValidation = () => {
  const [userRole, setUserRole] = useRecoilState(roleAtom)
  const user = useRecoilValue(userAtom)
  const queryParams = new URLSearchParams(window.location.search)
  const accessKey = queryParams.get('access')

  // The auth level comes only from verified sources — the role bound to
  // the validated edit token, else the Auth0 identity. The access URL
  // parameter never grants a role.
  useEffect(() => {
    const tokenRole = sessionStorage.getItem(EDIT_TOKEN_STORAGE_KEYS.role)
    if (
      tokenRole === EDIT_TOKEN_ROLE.DESIGNER ||
      tokenRole === EDIT_TOKEN_ROLE.QC
    ) {
      setUserRole(EDITOR_USER_ROLE.MESSENGER)
      return
    }
    if (tokenRole === EDIT_TOKEN_ROLE.FH_ADMIN) {
      setUserRole(EDITOR_USER_ROLE.FH)
      return
    }

    if (user?.type === userTypes.superAdmin) {
      setUserRole(EDITOR_USER_ROLE.MESSENGER)
      return
    }

    setUserRole(EDITOR_USER_ROLE.FH)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.type, accessKey])

  return userRole
}
